import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
export function SelfDefenseReviews() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-3024">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3025">
        <h2 className="text-4xl md:text-5xl text-ink text-center mb-16" data-id="element-3026">
          Real Reviews from Local Families
        </h2>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-3027">
          {STORM_REVIEWS.slice(0, 3).map(review => <ReviewCard key={review.name} quote={review.quote} name={review.name} label={review.label} data-id="element-3028" />)}
        </div>
        <p className="text-center text-sm text-gray-warm mt-8" data-id="element-3029">
          ★★★★★ 5.0 Rating From 201 Reviews
        </p>
      </div>
    </section>;
}